import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsFourArticlesHighlightBlock_Box_1 = styled.div`
  margin-top: 32px;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 52px;
  }
`;

export const CmsFourArticlesHighlightBlock_Box_2 = styled.div`
  margin-inline: ${-gutterWidth / 4}px;
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-inline: ${-gutterWidth / 2}px;
  }
`;

export const CmsFourArticlesHighlightBlock_Box_3 = styled.div`
  margin-bottom: ${gutterWidth / 2}px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: ${gutterWidth}px;
  }
`;
